import { Perm_recep_ant } from './../../../models/perm_recep_ant.model';
import { Component, ViewChild, TemplateRef } from "@angular/core";
import * as moment from 'moment'
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { FormService } from 'src/app/services/form.service';
import { MatDialog } from '@angular/material';
declare var jQuery: any;
declare var $: any;
@Component({
    selector: "page-perm_recep_ant",
    templateUrl: "./perm_recep_ant.component.html",
    styleUrls: ["./perm_recep_ant.component.css"],
    providers: [FormService]
})

export class Perm_recep_antComponent {
    @ViewChild('openModal') openModal: TemplateRef<any>;
    @ViewChild('openModalNODATA') openModalNODATA: TemplateRef<any>;

    public rows = [];
    public actualRow;
    public perm_recep_ant: Perm_recep_ant;
    public form;
    public temp_perm;
    public matcher = new FormService();
    public maxDate;
    constructor(private fb: FormBuilder, private dialog: MatDialog) {
        this.maxDate = moment().toDate()

        this.form = new FormGroup({
            permiso: new FormControl(''),
            numero: new FormControl('', [Validators.min(0),Validators.pattern(/[0-9]*/)]),
            fecha: new FormControl({ value: '', disabled: true }),
            superficie: new FormControl(''),
            recepcion: new FormControl(''),
            fecha_recep: new FormControl({ value: '', disabled: true }),

        })


        if (!JSON.parse(localStorage.getItem("perm_recep_ant"))) {
            localStorage.setItem("perm_recep_ant", JSON.stringify(this.rows));
        } else {
            this.rows = JSON.parse(localStorage.getItem("perm_recep_ant"));

        }
        this.perm_recep_ant = { permiso: '', numero: 0, fecha: null, superficie: 0, recepcion: '', fecha_recep: null };
        this.temp_perm = { permiso: '', numero: 0, fecha: null, superficie: 0, recepcion: '', fecha_recep: null };

    }

    add_permisos_recep() {

        this.actualRow = localStorage.getItem("perm_recep_ant");
        this.rows = JSON.parse(this.actualRow);

        if (!this.form.value.permiso && !this.form.value.numero && !this.form.value.superficie && !this.form.value.recepcion) {
            console.log("no se ingresaron datos add_permisos_recep")
            this.dialog.open(this.openModalNODATA);

        } else {
            this.rows = this.rows.concat({
                permiso: this.form.value.permiso,
                numero: this.form.value.numero,
                fecha: moment(this.form.value.fecha).format("DD/MM/YYYY"),
                superficie: this.form.value.superficie,
                recepcion: this.form.value.recepcion,
                fecha_recep: moment(this.form.value.fecha_recep).format("DD/MM/YYYY")

            })
            localStorage.setItem("perm_recep_ant", JSON.stringify(this.rows));
            this.form.reset();
        }

    }
    delete_permisos_recep(id) {
        for (let x = 0; x < this.rows.length; x++) {
            if (id == x) {
                this.rows.splice(x, 1);
                localStorage.setItem("perm_recep_ant", JSON.stringify(this.rows));
            }
        }
    }

    onChangeSelect(event) {
        let value = event.target.value;
        console.log(value);
    }
    get_permisos_recep(id) {
        console.log(id)
        for (let x = 0; x < this.rows.length; x++) {

            if (id == x) {
                this.temp_perm.id = id;
                this.temp_perm.permiso = this.rows[x].permiso;
                this.temp_perm.numero = this.rows[x].numero;
                this.temp_perm.fecha = this.rows[x].fecha;
                this.temp_perm.superficie = this.rows[x].superficie;
                this.temp_perm.recepcion = this.rows[x].recepcion;
                this.temp_perm.fecha_recep = this.rows[x].fecha_recep;

                console.log(this.temp_perm);
                this.dialog.open(this.openModal);

            }
        }
    }

    cleanData() {
        this.temp_perm = { permiso: '', numero: 0, fecha: null, superficie: 0, recepcion: '', fecha_recep: null };

    }

    savepermisos_recep() {
        var id = this.temp_perm.id;
        console.log(this.temp_perm)
        for (let x = 0; x < this.rows.length; x++) {
            if (id == x) {
                this.rows.splice(x, 1);
                localStorage.setItem("perm_recep_ant", JSON.stringify(this.rows));

                $("#antec_modal").modal("hide");
                this.actualRow = localStorage.getItem("perm_recep_ant");
                this.rows = JSON.parse(this.actualRow);
                this.rows = this.rows.concat({
                    permiso: this.temp_perm.permiso,
                    numero: this.temp_perm.numero,
                    fecha: this.temp_perm.fecha,
                    superficie: this.temp_perm.superficie,
                    recepcion: this.temp_perm.recepcion,
                    fecha_recep: this.temp_perm.fecha_recep,

                })
                localStorage.setItem("perm_recep_ant", JSON.stringify(this.rows));
                //this.temp_perm.reset();
                this.dialog.closeAll();
            }
        }
    }

}